import {
  Flex,
  TabList,
  Tabs,
  Tab,
  TabPanel,
  TabPanels,
} from "@chakra-ui/react";
import { YIELD_TEXT_STRINGS } from "../contants";
import { YieldDeposit, YieldWithdraw } from "./Tabs";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { updateUserData } from "store";
import { RSETH } from "@config/contractsConfig";

const TABS_DATA = YIELD_TEXT_STRINGS.SECTIONS.DEPOSIT_WITHDRAW.TABS;

const YieldDWBSection = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      updateUserData({
        selectedERC20YieldVault: RSETH,
      })
    );
  }, [dispatch]);

  return (
    <Flex flexDir="column" gap="16px" w="100%" maxW={"736px"}>
      <Flex
        flexDir="column"
        pt="4px"
        pb="10px"
        gap="40px"
        borderRadius="24px"
        bg="white"
      >
        <Tabs>
          <TabList fontWeight="600" lineHeight="24px">
            {TABS_DATA.map((data) => (
              <Tab
                fontSize={{ base: "12px", xl: "14px" }}
                key={data.key}
                py="8px"
              >
                {data.title}
              </Tab>
            ))}
          </TabList>

          <TabPanels>
            <TabPanel p="0">
              <YieldDeposit />
            </TabPanel>
            <TabPanel p="0">
              <YieldWithdraw />
            </TabPanel>
            {/* <TabPanel>
              <YieldBridge />
            </TabPanel> */}
          </TabPanels>
        </Tabs>
      </Flex>
    </Flex>
  );
};

export default YieldDWBSection;
